<template>
    <div class="zhezhao" v-if="showSignPay">
      <div class="demo-container tankuang">
        <div class="header">
          <div class="header-right" o @click="hidder()">x</div>
        </div>
  
        <div class="demo-left" style="overflow-x: scroll">
          <div
            class="step-box animated"
            style="display: flex; flex-direction: column"
          >
            <div class="my-title-box">
              <div class="my-title">扫码缴费</div>
              <!-- <div class="my-subtitle"> -->
              <!-- 第一步:扫码缴费,第二步:上传缴费凭证,第三步:点击完成 -->
              <el-steps simple style="margin-top: 20px">
                <el-step
                  title="扫码缴费"
                  icon="iconfont icon-saoma"
                  status="finish"
                ></el-step>
                <el-step
                  title="上传缴费证明"
                  icon="iconfont icon-shangchuan"
                  status="finish"
                ></el-step>
                <el-step
                  title="点击完成"
                  icon="iconfont icon-wancheng"
                  status="finish"
                ></el-step>
              </el-steps>
              <!-- </div> -->
            </div>
  
            <div class="rczp-row" style="margin-top: 35px">
              <div style="width: 50%; padding: 0 15%">
                <div>
                  <img src="@/assets/image/fukuan.png" alt="" />
                </div>
              </div>
              <div class="rczp-col rczp-col-2 upload_table">
                <span class="rczp-form-label">缴费证明：</span>
                <el-upload
                  class="avatar-uploader upload_table"
                  :action="uploadImgUrl"
                  :show-file-list="false"
                  :on-success="payUploadSuccess"
                  :before-upload="handleBeforeUpload"
                  :headers="headers"
                  :limit="1"
                  :disabled="signupInfo.payStatus == 1"
                  accept=".jpg,.png,.jpeg"
                >
                  <img
                    v-if="signupInfo.payContent"
                    :src="signupInfo.payContent"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
            <div class="mybtns" id="step2BtnTwo" style="position: unset">
              <button class="step3 default-btn next-btn" @click="showTip()">
                完成
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import request from "@/request";
  export default {
    name: "SignUp",
    props: {
      recruitId: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        uploadImgUrl: request.uploadFile, // 上传的图片服务器地址
        headers: {
          Authorization: this.$cookies.get(this.$commons.User.Authentication),
        },
        fileType: ["png", "jpg", "jpeg"],
        showSignPay: false,
        signupInfo: {},
      };
    },
    watch: {},
    mounted() {
      let _this = this;
      // _this.getSignupInfo();
    },
    created() {},
    methods: {
      hidder() {
        let _this = this;
        if (!_this.signupInfo.payStatus) {
          _this.$layer.confirm(
            "缴费证明未上传或未点击完成,是否关闭此窗口?",
            {
              btn: ["确定", "取消"], // 按钮
            },
            function (index) {
              _this.showSignPay = false;
              _this.signupInfo = {};
              _this.$layer.close(index);
            },
            function (index) {
              _this.$layer.close(index);
            }
          );
        } else {
          _this.showSignPay = false;
          _this.signupInfo = {};
        }
      },
      showTip() {
        let _this = this;
        if (!_this.signupInfo.payContent) {
          _this.$layer.alert("请上传缴费证明!");
          return;
        }
        let param = {
          id: _this.signupInfo.id,
          payContent: _this.signupInfo.payContent,
        };
        _this.$api.sign
          .signPay(param)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              _this.signupInfo.payStatus = 1;
            }
            _this.$layer.alert(res.msg, function (index) {
              _this.showSignPay = false;
              _this.$emit("update:showSignPay", false);
              _this.$emit('getMySign');
              _this.$layer.close(index);
            });
          })
          .catch(() => {})
          .finally(() => {});
      },
      getSignUpById(id) {
        let _this = this;
        let params = {
          id: id,
        };
        _this.$api.sign
          .getById(params)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              if (res.data) {
                _this.signupInfo = res.data;
              }
            } else {
              _this.$layer.alert(res.msg);
            }
          })
          .catch(() => {})
          .finally(() => {});
      },
  
      // 上传成功回调
      payUploadSuccess(res) {
        let _this = this;
        // this.fileList = [];
        // this.fileList.push({ name: res.data.url, url: res.data.url });
        _this.signupInfo.payContent = res.data.url;
        _this.$forceUpdate();
        _this.$modal.closeLoading();
      },
      // 上传前loading加载
      handleBeforeUpload(file) {
        let isImg = false;
        if (this.fileType.length) {
          let fileExtension = "";
          if (file.name.lastIndexOf(".") > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
          }
          isImg = this.fileType.some((type) => {
            if (file.type.indexOf(type) > -1) return true;
            if (fileExtension && fileExtension.indexOf(type) > -1) return true;
            return false;
          });
        } else {
          isImg = file.type.indexOf("image") > -1;
        }
  
        if (!isImg) {
          this.$modal.msgError(
            `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
          const isLt = file.size / 1024 / 1024 < 5;
          if (!isLt) {
            this.$modal.msgError(`上传图片大小不能超过 5MB!`);
            return false;
          }
       
        this.$modal.loading("正在上传图片，请稍候...");
      },
    },
  };
  </script>
  <style scoped>
  select {
    width: 100px;
    background: #fff;
    border: 1px solid #ededed;
    padding: 2px 0 2px 5px;
    border-radius: 4px;
  }
  
  .header-right {
    position: absolute;
    width: 25px;
    height: 25px;
    border-radius: 5px;
    background: #909399;
    color: #fff;
    right: 5px;
    top: 5px;
    text-align: center;
    cursor: pointer;
  }
  .header {
    height: 40px;
  }
  .tankuang {
    position: relative;
    background: #fff;
    height: 80%;
    border-radius: 5px;
    margin: 5% auto;
  }
  
  input.error {
    border: 1px solid red !important;
  }
  
  label.error {
    font-size: 12px;
    color: #ea5200;
  }
  .rowBtn {
    width: 88px !important;
    height: 34px;
    background: none;
    border: 1px #ccc solid;
    color: #333;
    margin-left: 10px;
  }
  .table {
    width: 100%;
    border-top: 1px #ddd solid;
    border-left: 1px #ddd solid;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 4px;
  }
  .table tr td {
    border-right: 1px #ddd solid;
    border-bottom: 1px #ddd solid;
    padding: 4px 15px;
    height: 40px;
  }
  
  .table input {
    /* height: 30px; */
    border: 1px #ddd solid;
    border-radius: 5px;
    padding-left: 10px;
    width: 100px;
  }
  .innertable input {
    width: 100px;
  }
  .table textarea {
    width: 100%;
    height: 100px;
    flex: 1;
    border: 1px #ddd solid;
    border-radius: 5px;
    padding-left: 10px;
  }
  .tdcenter {
    text-align: center;
  }
  
  .upload_table >>> ::v-deep .el-upload__input {
    display: none !important;
  }
  .upload_table >>> ::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader >>> .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  </style>
  <style>
  .el-date-editor .el-range__close-icon {
    width: 0px !important;
  }
  </style>


// WEBPACK FOOTER //
// src/components/signPay.vue